import { render } from "./QuestionWrapper.vue?vue&type=template&id=7656b878"
import script from "./QuestionWrapper.vue?vue&type=script&lang=js"
export * from "./QuestionWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__